import DocumentLink from './DocumentLink'
import type { DocumentRef, ReaderContext } from '../../lib/documentReader'

/** Every known document remains individually visible; filenames never group identity. */
export default function SourceDocumentList({
  documents,
  context,
}: {
  documents: DocumentRef[]
  context?: ReaderContext
}) {
  const unique = new Map<string, DocumentRef>()
  for (const document of documents) {
    if (!document.document_id) continue
    const previous = unique.get(document.document_id)
    if (!previous || (!previous.display_title && document.display_title))
      unique.set(document.document_id, document)
  }
  if (!unique.size) return null
  return (
    <div
      className="reader-document-links"
      aria-label="Source documents"
      data-testid="source-document-links"
    >
      <span>Documents</span>
      {[...unique.values()].map((document) => (
        <DocumentLink key={document.document_id} document={document} context={context} />
      ))}
    </div>
  )
}
